var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabPrivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1703_46457)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1703_46457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1703_46457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2121 11.7254C13.5782 12.0915 14.1718 12.0915 14.5379 11.7254C14.904 11.3593 14.904 10.7657 14.5379 10.3996C14.1718 10.0334 13.5782 10.0334 13.2121 10.3996C12.846 10.7657 12.846 11.3593 13.2121 11.7254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 20.4375H4.6875C2.61643 20.4375 0.937504 18.7586 0.937504 16.6875V5.4375C0.937504 3.36642 2.61643 1.6875 4.6875 1.6875H19.3125C21.3836 1.6875 23.0625 3.36642 23.0625 5.4375V16.6875C23.0625 18.7586 21.3836 20.4375 19.3125 20.4375Z",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 22.3125V20.4375",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 20.4375V22.3125",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 5.4375V7.3125",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 11.0625C17.625 13.1336 15.9461 14.8125 13.875 14.8125C11.8039 14.8125 10.125 13.1336 10.125 11.0625C10.125 8.99142 11.8039 7.3125 13.875 7.3125C15.9461 7.3125 17.625 8.99142 17.625 11.0625Z",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 5.4375V7.3125",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 14.8125V16.6875",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00361 8.25L10.6274 9.1875",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1226 12.9375L18.7464 13.875",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00361 13.875L10.6274 12.9375",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1226 9.1875L18.7464 8.25",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 14.8125V16.6875",
    stroke: "white",
    strokeWidth: 1.45161,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1703_46457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabPrivate);
export default __webpack_public_path__ + "static/media/tabPrivate.06e45763055d137f78d7bdaf21992d3d.svg";
export { ForwardRef as ReactComponent };